export default "__VITE_ASSET__3953f01e__"